import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  ApiRef,
  BackstageIdentityApi,
  createApiRef,
  discoveryApiRef,
  identityApiRef,
  OAuthApi,
  oauthRequestApiRef,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import {
  AgentPlatformClient,
  agentPlatformApiRef,
} from '@rpt/backstage-plugin-agent-platform';

export const EntraDelegationAuthApiRef: ApiRef<
  OAuthApi &
    OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi
> = createApiRef({
  id: 'internal.auth.oauth2',
});

export const Auth0AuthApiRef = createApiRef<
  OAuthApi & OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({ id: 'internal.auth.auth0' });

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: Auth0AuthApiRef,
    deps: { discoveryApi: discoveryApiRef, oauthRequestApi: oauthRequestApiRef, configApi: configApiRef },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) => OAuth2.create({
      configApi, discoveryApi, oauthRequestApi,
      provider: { id: 'auth0', title: 'Sign in with Auth0', icon: () => null },
      defaultScopes: ['openid', 'profile', 'email', 'offline_access'],
      environment: configApi.getString('auth.environment'),
    }),
  }),
  createApiFactory({
    api: agentPlatformApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      identityApi: identityApiRef,
      oauthApi: Auth0AuthApiRef,
    },
    factory: ({ discoveryApi, identityApi, oauthApi }) =>
      new AgentPlatformClient(discoveryApi, identityApi, oauthApi),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: EntraDelegationAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
      OAuth2.create({
        configApi,
        discoveryApi,
        oauthRequestApi,
        provider: {
          id: 'oauth2',
          title: 'Connect Riverpoint Agent Platform',
          icon: () => null,
        },
        // offline_access is required for Azure AD to issue a refresh token at all — this is what
        // actually controls the scope requested by the frontend's OAuth2 flow (both initial
        // sign-in and silent refresh), independent of the backend's additionalScopes config in
        // app-config.yaml (confirmed live: that backend config alone did not change what showed
        // up in the failing /oauth2/refresh request's scope param).
        defaultScopes: ['profile', 'email', 'openid', 'offline_access'],
        // Not used for Agent Gateway. Chat forwards the Auth0 access token.
        environment: 'development',
      }),
  }),
  ScmAuth.createDefaultApiFactory(),
];
